// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"styles_warningIcon__3sWtQ"};